import { Section } from "@arp/react-ndbx";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import {
  formatDate,
  formatMobileNumber,
  toUpperFirstCharacterFirstWord,
} from "../../../utilities/mappingHelper";

function ReviewApplicationYourDetails({ personOne }) {
  const StyledLabel = styled((props) => (
    <Section mb={{ xs: 1, md: 1 }} sx={{ textAlign: "left" }} {...props} />
  ))(({}) => ({}));

  const StyledDescription = styled((props) => (
    <Section mb={{ xs: 2, md: 3 }} sx={{ textAlign: "left" }} {...props} />
  ))(({}) => ({}));

  return (
    <Section md={7} mb={{ xs: 3, md: 4 }}>
      <Section mb={{ xs: 3, md: 4 }}>
        <Typography variant="h3-bold">Your details</Typography>
      </Section>
      <StyledLabel>
        <Typography variant="label-large-bold">
          Are you a Permanent Resident of Australia?
        </Typography>
      </StyledLabel>
      <StyledDescription>
        <Typography variant="p3">
          {toUpperFirstCharacterFirstWord(personOne.residentQuestion)}
        </Typography>
      </StyledDescription>
      <StyledLabel>
        <Typography variant="label-large-bold">First name</Typography>
      </StyledLabel>
      <StyledDescription>
        <Typography variant="p3">{personOne.firstName}</Typography>
      </StyledDescription>
      <StyledLabel>
        <Typography variant="label-large-bold">Last name</Typography>
      </StyledLabel>
      <StyledDescription>
        <Typography variant="p3">{personOne.surname}</Typography>
      </StyledDescription>
      <StyledLabel>
        <Typography variant="label-large-bold">Gender</Typography>
      </StyledLabel>
      <StyledDescription>
        <Typography variant="p3">
          {toUpperFirstCharacterFirstWord(personOne.gender)}
        </Typography>
      </StyledDescription>
      <StyledLabel>
        <Typography variant="label-large-bold">Date of birth</Typography>
      </StyledLabel>
      <StyledDescription>
        <Typography variant="p3">{formatDate(personOne.dob)}</Typography>
      </StyledDescription>
      <StyledLabel>
        <Typography variant="label-large-bold">Email address</Typography>
      </StyledLabel>
      <StyledDescription>
        <Typography variant="p3">{personOne.emailAddress}</Typography>
      </StyledDescription>
      <StyledLabel>
        <Typography variant="label-large-bold">Mobile number</Typography>
      </StyledLabel>
      <StyledDescription>
        <Typography variant="p3">
          {formatMobileNumber(personOne.contactNumber)}
        </Typography>
      </StyledDescription>
      <StyledLabel>
        <Typography variant="label-large-bold">State</Typography>
      </StyledLabel>
      <StyledDescription>
        <Typography variant="p3">{personOne.state.toUpperCase()}</Typography>
      </StyledDescription>
      <StyledLabel>
        <Typography variant="label-large-bold">
          Have you smoked tobacco or any other substance in the last 12 months?
        </Typography>
      </StyledLabel>
      <StyledDescription>
        <Typography variant="p3">
          {toUpperFirstCharacterFirstWord(personOne.tobaccoQuestion)}
        </Typography>
      </StyledDescription>
      <StyledLabel>
        <Typography variant="label-large-bold">
          Do you have any other insurance with Allianz?
        </Typography>
      </StyledLabel>
      <StyledDescription>
        <Typography variant="p3">
          {personOne.otherAllianzInsuranceList ? "Yes" : "No"}
        </Typography>
      </StyledDescription>
    </Section>
  );
}

export default ReviewApplicationYourDetails;
